import React from 'react';
import { WorkPageLayout } from '../Layout';
import styles from './Guide.module.scss';

export const GuideStepTwo = () => (
  <WorkPageLayout
    leftContent={
      <div className={styles.guideLeftSection}>
        <span className={styles.guideStepLeft_1}>The</span>
        <span className={styles.guideStepLeft_2}>Guide</span>
        <span className={styles.guideStepLeft_3}>to a sustainable</span>
        <span className={styles.guideStepLeft_4}>technological</span>
        <span className={styles.guideStepLeft_5}>future</span>
      </div>
    }
    rightContent={
      <div className={styles.guideStepContentWrapper}>
        and you get: <br />
        <br />
        - an inspired and conscious community,
        <br />
        - customized solutions for the new economy,
        <br />
        - advanced and environmentally friendly digital tools
        <br />
        - a community of like-minded people who make <br /> TransparenTerra a unique place for
        furthering positive social and economic impacts.
      </div>
    }
  />
);
